import React from 'react';
import { Helmet } from 'react-helmet';
const AboutBanner = () => {
  return (
    <>
      <Helmet>
        <title>About us | Amizhth Techno Solutions</title>
      </Helmet>
      <div className="breatcome_area3 d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breatcome_title">
                {/* <div className="breatcome_title_inner pb-2">
                  <h2>About Us</h2>
                </div>
                <div className="breatcome_content">
                  <ul>
                    <li>
                      <a href="index.html">Home</a>
                      <i className="fa fa-angle-right"></i>{' '}
                      <a href="#"> Pages</a>
                      <i className="fa fa-angle-right"></i>
                      <span>About Us</span>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="why_choose_area pt-80 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="prfs_experience">
                <img src="/images/Team.webp" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6">
              <div>
                <p>
                  <b>Amizhth Techno Solutions,</b> established during the
                  COVID-19 pandemic in 2020, is built on the belief that
                  &ldquo;Victory comes from finding opportunities in
                  problems&rdquo;. In a short span of time, we have partnered
                  with multiple clients, helping them overcome business
                  challenges by offering comprehensive digital solutions under
                  one roof. This has made us a trusted, one-stop technology
                  partner for many. We are proud to have developed portals for
                  StartupTN and the Transport Commissionerate Office of the
                  Government of Tamil Nadu as part of our software development
                  services. These partnerships reflect our commitment to
                  delivering innovative solutions that drive progress.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <center>
          <h1>
            <b>We strongly uphold</b>
          </h1>
        </center>
      </div>

      <div className="flipbox_area pages mt-70 pb-70 two">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-6">
              <div className="techno_flipbox mb-30">
                <div className="techno_flipbox_font">
                  <div className="techno_flipbox_inner">
                    <div className="techno_flipbox_icon">
                      <center>
                        <img
                          src="/images/abt3.webp"
                          className="img-fluid w-50"
                        />
                      </center>
                    </div>
                    <div className="flipbox_title">
                      <p>Transparent Process</p>
                    </div>
                  </div>
                </div>
                <div
                  className="techno_flipbox_back"
                  style={{ backgroundImage: 'url(/images/feature1.jpg)' }}
                >
                  <div className="techno_flipbox_inner">
                    <div className="flipbox_title">
                      <p>
                        Foster transparent operations to quickly build client
                        trust and understanding.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-6">
              <div className="techno_flipbox mb-30">
                <div className="techno_flipbox_font">
                  <div className="techno_flipbox_inner">
                    <div className="techno_flipbox_icon">
                      <center>
                        <img
                          src="/images/abt4.webp"
                          className="img-fluid w-50"
                        />
                      </center>
                    </div>
                    <div className="flipbox_title">
                      <p>Innovative Solutions</p>
                    </div>
                  </div>
                </div>
                <div
                  className="techno_flipbox_back"
                  style={{ backgroundImage: 'url(/images/feature2.jpg)' }}
                >
                  <div className="techno_flipbox_inner">
                    <div className="flipbox_title">
                      <p>
                        Creative strategies delivering powerful and effective
                        results
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-6">
              <div className="techno_flipbox mb-30">
                <div className="techno_flipbox_font">
                  <div className="techno_flipbox_inner">
                    <div className="techno_flipbox_icon">
                      <center>
                        <img
                          src="/images/abt2.webp"
                          className="img-fluid w-50"
                        />
                      </center>
                    </div>
                    <div className="flipbox_title">
                      <p>Continuous Improvement</p>
                    </div>
                  </div>
                </div>
                <div
                  className="techno_flipbox_back"
                  style={{ backgroundImage: 'url(/images/feature3.jpg)' }}
                >
                  <div className="techno_flipbox_inner">
                    <div className="flipbox_title">
                      <p>Consistent progress for ongoing success.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flipbox_area pages pb-70 two">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-6">
              <div className="techno_flipbox mb-30">
                <div className="techno_flipbox_font">
                  <div className="techno_flipbox_inner">
                    <div className="techno_flipbox_icon">
                      <center>
                        <img
                          src="/images/abt6.webp"
                          className="img-fluid w-50"
                        />
                      </center>
                    </div>
                    <div className="flipbox_title">
                      <p>Trust and Reliability</p>
                    </div>
                  </div>
                </div>
                <div
                  className="techno_flipbox_back"
                  style={{ backgroundImage: 'url(/images/feature1.jpg)' }}
                >
                  <div className="techno_flipbox_inner">
                    <div className="flipbox_title">
                      <p>
                        Consistent support builds strong, lasting partnerships.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-6">
              <div className="techno_flipbox mb-30">
                <div className="techno_flipbox_font">
                  <div className="techno_flipbox_inner">
                    <div className="techno_flipbox_icon">
                      <center>
                        <img
                          src="/images/abt5.webp"
                          alt=""
                          className="img-fluid w-50"
                        />
                      </center>
                    </div>
                    <div className="flipbox_title">
                      <p>Clear Communication</p>
                    </div>
                  </div>
                </div>
                <div
                  className="techno_flipbox_back"
                  style={{ backgroundImage: 'url(/images/feature2.jpg)' }}
                >
                  <div className="techno_flipbox_inner">
                    <div className="flipbox_title">
                      <p>
                        Straightforward dialogue enhances collaboration and
                        understanding.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-6">
              <div className="techno_flipbox mb-30">
                <div className="techno_flipbox_font">
                  <div className="techno_flipbox_inner">
                    <div className="techno_flipbox_icon">
                      <center>
                        <img
                          src="/images/abt1.webp"
                          className="img-fluid w-50"
                        />
                      </center>
                    </div>
                    <div className="flipbox_title">
                      <p>Personalized Service</p>
                    </div>
                  </div>
                </div>
                <div
                  className="techno_flipbox_back"
                  style={{ backgroundImage: 'url(/images/feature3.jpg)' }}
                >
                  <div className="techno_flipbox_inner">
                    <div className="flipbox_title">
                      <p>
                        Tailored experiences meet unique client needs
                        effectively.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutBanner;
